import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import Seo from "../components/Seo";
import { PageRendererProps } from "gatsby";
import WavesBottom from "../components/WavesBottom";
import { FAQ, FAQSection } from "models";
import AccordionItem from "../components/AccordionItem";

const FaqPage = ({ location }: PageRendererProps) => {
  const [faqs, setFaqs] = useState<FAQSection[] | null>(null);

  useEffect(() => {
    const fetchJson = async () => {
      try {
        const result = await fetch(
          "https://getsby-public.s3.eu-central-1.amazonaws.com/support.json"
        );

        if (result) {
          const json: FAQ = await result.json();

          if (json && json.de) {
            setFaqs(json.de);
          }
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchJson();
  }, []);

  return (
    <Layout location={location}>
      <Seo title="Frequently asked questions" />

      <section className="bg-white py-20">
        <div className="container max-w-5xl mx-auto m-8 p-6">
          <h2 className="w-full my-8 sm:text-3xl lg:text-5xl font-bold leading-tight text-center text-gray-800">
            FAQ
          </h2>
          <h3 className="w-full my-8 sm:text-2xl lg:text-4xl font-bold leading-tight text-center text-gray-800">
            Frequently Asked Questions
          </h3>

          {faqs &&
            faqs.map((section) => (
              <React.Fragment>
                <h3 className="w-full my-8 sm:text-2xl lg:text-4xl font-bold leading-tight text-gray-800">
                  {section.title}
                </h3>
                <section className="shadow">
                  {section.questions.map((entry, index) => (
                    <AccordionItem
                      title={entry.question}
                      body={entry.answer}
                      key={index}
                    />
                  ))}
                </section>
              </React.Fragment>
            ))}

          <p className="text-gray-600 my-8">
            Noch Fragen? Unser{" "}
            <a href="mailto:support@gets.by" className="text-yellow-500">
              Support
            </a>{" "}
            hilft dir gerne weiter!
          </p>
        </div>
      </section>

      <WavesBottom />
    </Layout>
  );
};

export default FaqPage;
